import i18next from "i18next";

export const PAGE_SIZE = 20;
export const onShowMoreClick = (
  e: any,
  colname: string,
  t: i18next.TranslationFunction<any, object, string>
) => {
  const elements: any = document.querySelectorAll(
    `[data-id="${colname}-${e.target.id}"]`
  );

  const btnShowMore = document.querySelector(
    `[data-clicked="${e.target.id}-${colname}-NO"]`
  );
  const btnShowLess = document.querySelector(
    `[data-clicked="${e.target.id}-${colname}-YES"]`
  );

  if (btnShowMore) {
    for (let i = 0; i < elements.length; i++) {
      if (i > 2) {
        elements[i].style.display = "block";
      }
    }
    btnShowMore.setAttribute("data-clicked", `${e.target.id}-${colname}-YES`);
    btnShowMore.innerHTML = t("KUMA_VIEW:SHOW_LESS");
  } else if (btnShowLess) {
    for (let i = 0; i < elements.length; i++) {
      if (i > 2) {
        elements[i].style.display = "none";
      } else {
        elements[i].style.display = "block";
      }
    }
    btnShowLess.setAttribute("data-clicked", `${e.target.id}-${colname}-NO`);
    btnShowLess.innerHTML = t("KUMA_VIEW:SHOW_MORE");
  }
};
export const KUMA_COL_RESIZE = "KUMA_COL_RESIZE";
export const PSL_COL_RESIZE = "PSL_COL_RESIZE";
export const checkboxSelection = function (params: any) {
    // we put checkbox on the name if we are not doing grouping
    return params.columnApi.getRowGroupColumns().length === 0;
};

export const headerCheckboxSelection = function (params: any) {
    // we put checkbox on the name if we are not doing grouping
    return params.columnApi.getRowGroupColumns().length === 0;
};
export const onColumnResized = (event: any,viewname:string) => {
  if (event.finished) {
    const getColumn: any = localStorage.getItem(viewname);
    const { column } = event;
    if (getColumn && column) {
      const { colId, actualWidth } = column;
      const colums = JSON.parse(getColumn);
      let isColFound = false;
      const updatedCol = colums.map((col: any) => {
        if (col.colId === colId) {
          col = { colId, actualWidth };
          isColFound = true;
          return col;
        }
        return col;
      });
      if (!isColFound) {
        updatedCol.push({ colId, actualWidth });
      }
      localStorage.setItem(viewname, JSON.stringify(updatedCol));
    } else if (column) {
      const colums = [];
      colums.push({ colId: column.colId, actualWidth: column.actualWidth });
      localStorage.setItem(viewname, JSON.stringify(colums));
    }
  }
};
export const getWidth = (fieldId: string,viewname:string) => {
    const getColumns = localStorage.getItem(viewname);
    const widthSettings: any = getColumns && JSON.parse(getColumns);
    if (widthSettings) {
        const getField = widthSettings.find((p: any) => p.colId === fieldId);
        if (getField) {
            return getField.actualWidth;
        }
    }
    return 170;
};

export const getCurrentUserKumaRequirementVotes = (data: any, cn: string | undefined) =>
  data.votes.find(
    (p: any) => p.requirementId === data.objectId && cn && p.userCN.trim().toLowerCase() === cn.trim().toLowerCase()
  );

export const getKumaRequirementTotalVotes = (votes: any) =>
  votes
    .map((p: any) => p.stars)
    .reduce((total: number, n: number) => total + n, 0);



// WEBPACK FOOTER //
// ./src/views/KumaView/utils.ts